import { call, put, select, all, delay } from "redux-saga/effects";
import { actions as notificationsActions } from "@/reducers/notifications";
import {
  NOTIFICATIONS,
  TYPE_ORDER_COMPLETED,
  TYPE_NOT_ORDER_COMPLETED,
  TYPE_BD_COMPLETED,
  TYPE_NOT_BD_COMPLETED,
  DEBT_PAYMENT,
  TYPE_ONE_BILL,
  TYPE_BILLS,
  TYPE_PROMOTION,
  CLAIM_END,
  CLAIM_OPEN,
  TYPE_CITA_PREVIA_INSTALADOR,
  TYPE_CITA_PREVIA_TECNICO,
  TYPE_PREPAID_BALANCE,
  TYPE_PREPAID_RENEW,
  TYPE_PREPAID_INSUFFICIENT_DATA,
  TYPE_RENEWAL_R2R,
  TYPE_PERSONAL_ADVANTAGE_R2R,
  TYPE_PENDING_BD_COMPLETED,
  TYPE_DOWNLOAD_ESIM,
  TYPE_PENDING_ESIM,
  TYPE_ACTIVATE_DISNEY,
  BLOCKING_FOR_THEFT,
  MODEL_347,
  TYPE_ACTIVATE_MOVISTAR_PLUS,
} from "@/constants/notifications";
import { TYPE_EXTRA_EXPENSE } from "../constants/notifications";
import {
  ANULADO_AUTODIAGNOSTICO,
  CANCELADO_AUTODIAGNOSTICO,
  CANCELED_TRACKING_ORDER,
  EN_CURSO_AUTODIAGNOSTICO,
  FINALIZADO_AUTODIAGNOSTICO,
  FINISHED_TRACKING_ORDER,
  IN_PROGRESS_TRACKING_ORDER,
  INCIDENCE_TRACKING_ORDER,
  ESPERA_CLIENTE_AUTODIAGNOSTICO,
  PENDIENTE_CONFORMIDAD_AUTODIAGNOSTICO,
  PRIVATE_AREA_TYPES,
} from "@/constants/constants";
import {
  getFirstLinePhoneFromProductId,
  getPromotionalInfoByProduct,
  hasRestrictionByIdRestriction,
} from "@/utils/dataHandlers/ProductDataHandler";
import {
  getRecentInvoices,
  hasEndClaims,
  hasOpenClaims,
} from "@/utils/dataHandlers/NotificationsDataHandler";
import { actions as selfDiagnosisActions } from "@/reducers/selfDiagnosis";
import { createCycleObject } from "@/utils/dataHandlers/PrepaidDataHandler";
import isFrontApp from "@gcloud-npm/utils.common.is-front-app";
import dynamic from "next/dynamic";
import { actions as modalActions } from "@/bit/reducers/reducers.modals-reducer";
import getDeviceKindDependsOnViewPort from "@gcloud-npm/utils.common.get-device-kind-depends-on-viewport";
import {
  MODAL_BASIC_PROPS,
  MODAL_BASIC_PROPS_MOBILE,
} from "@/constants/modals";
import { useSelector } from "react-redux";
// import LocalStorageLib from "@gcloud-npm/utils.secure.local-storage";
import { hasSecureEsimPending } from "@/utils/utils";
import { SESION_ESIM_PENDING_ID } from "@/constants/constants";
import { getProductsByProductId } from "@/containers/my-products/utils";
import { DISALLOWED_STATES_CITA } from "@/constants/breakdown-detail-constants";
import { getMovistarPlusLiteURL } from "@/utils/tvUtils";

const contextStore = (state) => state.main.context;
const getAccumulatedUsagesStore = (state) => state.usages.accumulatedUsages;
const getHiredProducts = (state) => state.product.hiredProducts;
const getHiredProductsList = (state) => state.product.hiredProductsList;
const listTrackingStore = (state) => state.tracking.listTracking;
const breakdownTrackingStore = (state) => state.breakdown.trackingBreakdown;
const debtPaymentStore = (state) => state.client.debtPayment;
const billsStore = (state) => state.bills.bills;
const claimsStore = (state) => state.bills.billsClaims;
const getAccumulatedUsagesPrepaid = (state) =>
  state.prepaid.accumulatedUsagesPrepaid;
const getBalancePrepaid = (state) => state.prepaid.balancePrepaid;
const getUserInfo = (state) => state.user.userInfo;
const getTarifDetailPrepaidData = (state) =>
  state.prepaid.tarifDetailPrepaidData;
const getMyLineDetailMobileRestrictionStatus = (state) =>
  state.product.myLineDetailMobileRestrictionStatus;
const notificationStore = (state) => state.notifications;
const getEsimStatusInfo = (state) => state.product.esimStatusInfo;
const getProviderCompatibility = (state) =>
  state.thirdParties.providerCompatibility;
const getClientInfoStore = (state) => state.client.clientInfo;
const getSelfEmployedStore = (state) => state.user.selfEmployed;
const getMovistarLiteActivationStore = (state) => state.tv.movistarLiteActivation;
const getMovistarLiteStatusStore = (state) => state.tv.movistarLiteStatus;

const openDiagnosis = (issueId, productId, dispatch, phone) => {
  let objDiagnosis = {};
  objDiagnosis = {
    motiveId: issueId,
    productId: productId,
    comments: "Enviado desde autodiagnóstico TCOL",
    phone,
  };
  if (objDiagnosis && phone) {
    const notification = true;
    dispatch(selfDiagnosisActions.openDiagnosis(objDiagnosis, notification));
  }
};

const closeModal = () => {
  dispatch(modalActions.addModal({ type: "MODAL", id: "closeAll" }));
};

const launchModalBreakdownDetail = (cp, dispatch, navigate) => {
  const device = getDeviceKindDependsOnViewPort();
  const contentPosition =
    device === "MOBILE" ? MODAL_BASIC_PROPS_MOBILE : MODAL_BASIC_PROPS;
  const breakdownModal = dynamic(() =>
    import("@/containers/support/breakdown-unresolved-detail")
  );
  dispatch(
    modalActions.addModal({
      id: "detalle-averia",
      Element2Show: breakdownModal,
      modalProps: contentPosition,
      elementProps: {
        cp,
        closeModal,
        navigateProp: navigate,
      },
    })
  );
};

export const addNotificationTracking = ({
  list,
  type,
  origin,
  notificationsList,
}) => {
  let notification = null;
  if (list && Array.isArray(list) && list.length > 0) {
    const notifications = NOTIFICATIONS.filter(
      (noti) => noti?.type.includes(type) && noti?.pages.includes(origin)
    );
    notification =
      notifications &&
      Array.isArray(notifications) &&
      notifications.length > 0 &&
      notifications[0];
    if (notification) {
      notification.text = notification.text2;
      if (list.length === 1) {
        const [firstTrack] = list;
        if (firstTrack?.code && firstTrack?.detailAvailable) {
          notification.link = `${notification.linkToDetail}?co=${firstTrack.code}`;
          notification.text = notification.text1;
        }
      }
    }
  }
  if (notification) {
    notificationsList.push(notification);
  }
};

export const addNotificationCitaPrevia = ({
  list,
  type,
  origin,
  notificationsList,
  isBreakdown = false,
}) => {
  let notification = null;
  if (list && Array.isArray(list) && list.length > 0) {
    const notifications = NOTIFICATIONS.filter(
      (noti) => noti?.type.includes(type) && noti?.pages.includes(origin)
    );
    notification =
      notifications &&
      Array.isArray(notifications) &&
      notifications.length > 0 &&
      notifications[0];
    if (notification) {
      list.forEach((track) => {
        const newNotification = {
          ...notification,
        };
        const { citaInstalador } = track;
        if (citaInstalador?.id && citaInstalador?.dateInstalationStart) {
          newNotification.text = newNotification.text2; 
        }
        if (track.code) {
          if (isBreakdown) {
            newNotification.link = `${notification.linkToDetail}?cp=${track.code}`;
          } else {
            newNotification.link = `${notification.linkToDetail}?co=${track.code}`;
          }
          notificationsList.push(newNotification);
        }
      });
    }
  }
};

export const addNotificationBreakdown = ({
  list,
  type,
  origin,
  notificationsList,
  clientInfo,
}) => {
  let notification = null;
  if (list && Array.isArray(list) && list.length > 0) {
    const notifications = NOTIFICATIONS.filter(
      (noti) => noti?.type.includes(type) && noti?.pages.includes(origin)
    );
    notification =
      notifications &&
      Array.isArray(notifications) &&
      notifications.length > 0 &&
      notifications[0];
    if (notification) {
      list.forEach((track) => {
        const newNotification = {
          ...notification,
        };
        if (track.estado === ESPERA_CLIENTE_AUTODIAGNOSTICO) {
          newNotification.text = newNotification.textPaused;
        }
        if (track.code) {
          // newNotification.onClick = (dispatch, navigate) => {
          //   launchModalBreakdownDetail(track.code, dispatch, navigate);
          //   const hasProductRefIdAndMotiveId =
          //     track.productRef &&
          //     track.productRef.id &&
          //     track.motive &&
          //     track.motive.id;
          //   if (
          //     track.estado === EN_CURSO_AUTODIAGNOSTICO &&
          //     hasProductRefIdAndMotiveId
          //   ) {
          //     const phone =
          //       clientInfo &&
          //       Array.isArray(clientInfo.contactsPhones) &&
          //       clientInfo.contactsPhones[0] &&
          //       clientInfo.contactsPhones[0].value;
          //     openDiagnosis(
          //       track.motive.id,
          //       track.productRef.id,
          //       dispatch,
          //       phone
          //     );
          //   }
          // };
          newNotification.link = `${newNotification.linkToDetail}?cp=${track.code}`;
          notificationsList.push(newNotification);
        }
      });
    }
  }
};

export const addNotificationEsim = ({
  list,
  type,
  origin,
  notificationsList,
}) => {
  let notification = null;

  if (list && Array.isArray(list) && list.length > 0) {
    const notifications = NOTIFICATIONS.filter(
      (noti) => noti?.type.includes(type) && noti?.pages.includes(origin)
    );
    notification =
      notifications &&
      Array.isArray(notifications) &&
      notifications.length > 0 &&
      notifications[0];
    if (notification) {
      list.forEach((product) => {
        const newNotification = {
          ...notification,
        };
        if (product.productId) {
          newNotification.text = `${notification.text} ${product.phone}`;
          newNotification.link = `${notification.linkToDetail}?productId=${product.productId}`;
          notificationsList.push(newNotification);
        }
      });
    }
  }
};

export const addNotification = ({ notification, notificationsList, text }) => {
  if (notification) {
    notification.forEach((item, index) => {
      const newItem = {
        ...item,
      };
      if (text) {
        newItem.text = `${newItem.text} ${text}`;
      }
      notificationsList.push(newItem);
    });
  }
};

export const isDateWithinTenDays = (dateString) => {
  if (dateString) {
    const parts = dateString.split("-");
    const day = parseInt(parts[0]);
    const month = parseInt(parts[1]) - 1;
    const year = parseInt(parts[2]);
    const date = new Date(year, month, day);
    const today = new Date();
    date.setDate(date.getDate() + 10);
    return date > today;
  }
  return null;
};

export const getCurrentDate = () => {
  const currentDate = new Date();
  const year = currentDate.getFullYear();
  const month = currentDate.getMonth() + 1;
  return year * 100 + month;
};

export const filterDates = (object) => {
  const currentDate = getCurrentDate();
  const currentMonth = currentDate % 100;
  const currentYear = Math.floor(currentDate / 100);
  const previousMonth = currentMonth === 1 ? 12 : currentMonth - 1;

  const filteredObject = {};
  for (const key in object) {
    if (object.hasOwnProperty(key)) {
      const year = parseInt(key.substring(0, 4));
      const month = parseInt(key.substring(4, 6));
      if (
        (year === currentYear && month === currentMonth) ||
        (year === currentYear && month === previousMonth)
      ) {
        filteredObject[key] = object[key];
      }
    }
  }
  return filteredObject;
};

export const getBillsNotifications = ({
  notificationsList,
  billsObject,
  claimsObject,
  origin,
}) => {
  if (billsObject) {
    const bills = Object.values(claimsObject).flat();
    if (bills && Array.isArray(bills) && bills.length > 0) {
      const recentBills = getRecentInvoices(bills);
      if (recentBills && Array.isArray(recentBills) && recentBills.length > 0) {
        const openClaims = hasOpenClaims(recentBills);
        const endClaims = hasEndClaims(recentBills);
        const type = recentBills.length === 1 ? TYPE_ONE_BILL : TYPE_BILLS;
        let notification = NOTIFICATIONS.filter(
          (noti) => noti?.type.includes(type) && noti?.pages.includes(origin)
        );
        addNotification({ notification, notificationsList });
        if (openClaims) {
          notification = NOTIFICATIONS.filter(
            (noti) =>
              noti?.type.includes(CLAIM_OPEN) && noti?.pages.includes(origin)
          );
          addNotification({ notification, notificationsList });
        }
        if (endClaims) {
          notification = NOTIFICATIONS.filter(
            (noti) =>
              noti?.type.includes(CLAIM_END) && noti?.pages.includes(origin)
          );
          addNotification({ notification, notificationsList });
        }
      }
    }
  }
};

export const getUsagesNotifications = ({
  accumulatedUsagesAlreadyFetched,
  notificationsList,
  hiredProducts,
  origin,
  productId,
}) => {
  let totalExtraSum = null;
  let productIdToDetail = null;
  if (productId) {
    if (
      origin === PRIVATE_AREA_TYPES.detalleFijo ||
      origin === PRIVATE_AREA_TYPES.detalleInternet
    ) {
      const linePhone = getFirstLinePhoneFromProductId(
        hiredProducts,
        productId
      );
      productIdToDetail = linePhone?.productId;
    } else if (origin === PRIVATE_AREA_TYPES.detalleMovil) {
      productIdToDetail = productId;
    }
    if (
      accumulatedUsagesAlreadyFetched &&
      Array.isArray(accumulatedUsagesAlreadyFetched) &&
      accumulatedUsagesAlreadyFetched.length > 0
    ) {
      const currentAccumulatedUsage = accumulatedUsagesAlreadyFetched.find(
        (usage) => usage.productId === productIdToDetail
      );
      if (
        currentAccumulatedUsage?.period &&
        Array.isArray(currentAccumulatedUsage?.period) &&
        currentAccumulatedUsage?.period.length > 0
      ) {
        totalExtraSum = currentAccumulatedUsage.period[0].totalExtra;
      }
    }
  } else {
    if (
      accumulatedUsagesAlreadyFetched &&
      Array.isArray(accumulatedUsagesAlreadyFetched) &&
      accumulatedUsagesAlreadyFetched.length > 0
    ) {
      accumulatedUsagesAlreadyFetched.forEach((usage) => {
        if (
          usage?.period &&
          Array.isArray(usage?.period) &&
          usage?.period.length > 0
        ) {
          totalExtraSum += usage.period[0].totalExtra;
        }
      });
    }
  }

  if (totalExtraSum > 0) {
    let notification = NOTIFICATIONS.filter(
      (noti) =>
        noti?.type.includes(TYPE_EXTRA_EXPENSE) && noti?.pages.includes(origin)
    );
    addNotification({ notification, notificationsList });
  }
};

export const getTrackingNotifications = ({
  listTracking,
  notificationsList,
  origin,
}) => {
  if (listTracking && Array.isArray(listTracking) && listTracking.length > 0) {
    const citaPreviaTracking = listTracking.filter(
      (track) =>
        track.citaInstalador &&
        track.citaInstalador.idWo &&
        !DISALLOWED_STATES_CITA.includes(track?.citaInstalador?.state) &&
        track.state !== INCIDENCE_TRACKING_ORDER &&
        track.state !== CANCELED_TRACKING_ORDER &&
        track.state !== FINISHED_TRACKING_ORDER
    );
    if (
      citaPreviaTracking &&
      Array.isArray(citaPreviaTracking) &&
      citaPreviaTracking.length > 0
    ) {
      addNotificationCitaPrevia({
        list: citaPreviaTracking,
        type: TYPE_CITA_PREVIA_INSTALADOR,
        origin,
        notificationsList,
      });
    }
    const finishedTracking = listTracking.filter(
      (track) =>
        track.state === FINISHED_TRACKING_ORDER &&
        isDateWithinTenDays(track?.dateEnd)
    );
    if (
      finishedTracking &&
      Array.isArray(finishedTracking) &&
      finishedTracking.length > 0
    ) {
      addNotificationTracking({
        list: finishedTracking,
        type: TYPE_ORDER_COMPLETED,
        origin,
        notificationsList,
      });
    }
    const inProgressTracking = listTracking.filter(
      (track) => track.state === IN_PROGRESS_TRACKING_ORDER
    );
    if (
      inProgressTracking &&
      Array.isArray(inProgressTracking) &&
      inProgressTracking.length > 0
    ) {
      addNotificationTracking({
        list: inProgressTracking,
        type: TYPE_NOT_ORDER_COMPLETED,
        origin,
        notificationsList,
      });
    }
  }
};

export const getBreackingdownNotifications = ({
  notificationsList,
  breakdownTracking,
  origin,
  clientInfo,
}) => {
  if (
    breakdownTracking?.technicalCustomerProblems &&
    Array.isArray(breakdownTracking?.technicalCustomerProblems) &&
    breakdownTracking?.technicalCustomerProblems.length > 0
  ) {
    const citaPreviaBreackdown =
      breakdownTracking.technicalCustomerProblems.filter(
        (track) =>
          track.citaInstalador &&
          track.citaInstalador.idWo &&
          !DISALLOWED_STATES_CITA.includes(track?.citaInstalador?.state) &&
          track.estado !== FINALIZADO_AUTODIAGNOSTICO &&
          track.estado !== CANCELADO_AUTODIAGNOSTICO &&
          track.estado !== ANULADO_AUTODIAGNOSTICO
      );
    if (
      citaPreviaBreackdown &&
      Array.isArray(citaPreviaBreackdown) &&
      citaPreviaBreackdown.length > 0
    ) {
      const isBreakdown = true;
      addNotificationCitaPrevia({
        list: citaPreviaBreackdown,
        type: TYPE_CITA_PREVIA_TECNICO,
        origin,
        notificationsList,
        isBreakdown,
      });
    }
    const finishedBreakdown =
      breakdownTracking.technicalCustomerProblems.filter(
        (track) =>
          track.estado === FINALIZADO_AUTODIAGNOSTICO &&
          isDateWithinTenDays(track?.endDate)
      );
    if (
      finishedBreakdown &&
      Array.isArray(finishedBreakdown) &&
      finishedBreakdown.length > 0
    ) {
      addNotificationBreakdown({
        list: finishedBreakdown,
        type: TYPE_BD_COMPLETED,
        origin,
        notificationsList,
        clientInfo,
      });
    }

    const pendingBreakdown = breakdownTracking.technicalCustomerProblems.filter(
      (track) => track.estado === PENDIENTE_CONFORMIDAD_AUTODIAGNOSTICO
    );
    if (
      pendingBreakdown &&
      Array.isArray(pendingBreakdown) &&
      pendingBreakdown.length > 0
    ) {
      addNotificationBreakdown({
        list: pendingBreakdown,
        type: TYPE_PENDING_BD_COMPLETED,
        origin,
        notificationsList,
        clientInfo,
      });
    }

    const notFinishedBreakdown =
      breakdownTracking.technicalCustomerProblems.filter(
        (track) =>
          track.estado !== FINALIZADO_AUTODIAGNOSTICO &&
          track.estado !== CANCELADO_AUTODIAGNOSTICO &&
          track.estado !== ANULADO_AUTODIAGNOSTICO &&
          track.estado !== PENDIENTE_CONFORMIDAD_AUTODIAGNOSTICO
      );
    if (
      notFinishedBreakdown &&
      Array.isArray(notFinishedBreakdown) &&
      notFinishedBreakdown.length > 0
    ) {
      addNotificationBreakdown({
        list: notFinishedBreakdown,
        type: TYPE_NOT_BD_COMPLETED,
        origin,
        notificationsList,
        clientInfo,
      });
    }
  }
};

export const getDebtPaymentNotification = ({
  notificationsList,
  debtPayment,
  origin,
}) => {
  if (debtPayment && debtPayment.deuda) {
    let notification = NOTIFICATIONS.filter(
      (noti) =>
        noti?.type.includes(DEBT_PAYMENT) && noti?.pages.includes(origin)
    );
    addNotification({ notification, notificationsList });
  }
};

export const getPromotionNotification = ({
  notificationsList,
  hiredProducts,
  origin,
}) => {
  if (!Array.isArray(hiredProducts) || hiredProducts.length === 0) return;

  const notification = NOTIFICATIONS.filter(
    (noti) =>
      noti?.type.includes(TYPE_PROMOTION) && noti?.pages.includes(origin)
  );

  hiredProducts.forEach((product) => {
    const promotion = getPromotionalInfoByProduct(product);

    if (promotion?.endDate) {
      addNotification({
        notification,
        notificationsList,
        text: promotion.endDate,
      });
    }
  });
};


export const getCustoNotification = async ({
  context,
  notificationsList,
  origin,
  userRecom,
}) => {
  const getByName = await import("@gcloud-npm/adabyron.custo.get-by-name");

  let notification = await getByName.default({
    name: "CMS-GP-AC-NOTIFICACION",
    context: context,
    kind: "activity",
    custoVersion: 3,
    userRecom,
  });

  const notEmpty = notification?.creativityName !== "CMS-EMPTY-CONTENT";
  const filterPage =
    Array.isArray(notification?.pages) && notification?.pages.includes(origin);

  if (notEmpty && filterPage) {
    notificationsList.push(notification);
  }
};

export const getPrepaidNotifications = ({
  origin,
  notificationsList,
  balancePrepaid,
  accumulatedUsagesPrepaid,
  tarifDetailPrepaidData,
}) => {
  if (balancePrepaid) {
    let notification = NOTIFICATIONS.filter(
      (noti) =>
        noti?.type.includes(TYPE_PREPAID_BALANCE) &&
        noti?.pages.includes(origin)
    )[0];
    if (notification) {
      const balances = Object.keys(balancePrepaid);
      let showBalanceNotification = false;
      balances.forEach((balanceProductId) => {
        const balanceInt = parseInt(
          balancePrepaid[balanceProductId].balance.match(/(\d+)/)[0]
        );
        if (balanceInt <= 3 && !showBalanceNotification) {
          showBalanceNotification = true;
          notification.link = `${notification.linkToDetail}`;
          addNotification({ notification: [notification], notificationsList });
        }
      });
    }
  }

  if (accumulatedUsagesPrepaid) {
    let notification = NOTIFICATIONS.filter(
      (noti) =>
        noti?.type.includes(TYPE_PREPAID_INSUFFICIENT_DATA) &&
        noti?.pages.includes(origin)
    );

    if (notification) {
      let showInsufficientNotification = false;
      accumulatedUsagesPrepaid.forEach((usage) => {
        if (
          (usage.period[0].data.current >= usage.period[0].data.maxValue ||
            usage.period[0].data.maxValue < 0) &&
          !showInsufficientNotification
        ) {
          showInsufficientNotification = true;
          notification[0].link = `${notification[0].linkToDetail}`;
          addNotification({ notification, notificationsList });
        }
      });
    }
    if (accumulatedUsagesPrepaid && balancePrepaid && tarifDetailPrepaidData) {
      let notification = NOTIFICATIONS.filter(
        (noti) =>
          noti?.type.includes(TYPE_PREPAID_RENEW) &&
          noti?.pages.includes(origin)
      );
      let showRechargePrepaidNotification = false;
      accumulatedUsagesPrepaid.forEach((usage) => {
        if (usage.period[0].nextRenewalDate) {
          const cyclePrepaid = createCycleObject(
            usage.period[0].nextRenewalDate,
            usage.productId
          );
          const balanceInt = parseInt(
            balancePrepaid[usage.productId].balance.match(/(\d+)/)[0]
          );

          if (
            cyclePrepaid.remainingDays <= 2 &&
            balanceInt < tarifDetailPrepaidData[usage.productId].price &&
            !showRechargePrepaidNotification
          ) {
            showRechargePrepaidNotification = true;
            notification[0].link = `${notification[0].linkToDetail}`;
            addNotification({ notification, notificationsList });
          }
        }
      });
    }
  }
};

export const getRenewalR2RNotifications = ({
  notificationsList,
  userInfo,
  origin,
}) => {
  if (userInfo?.includedR2RInfo) {
    const { isCancellable, productName } = userInfo.includedR2RInfo;
    if (isCancellable) {
      const formattedDate = productName;
      let notification = NOTIFICATIONS.filter(
        (noti) =>
          noti?.type.includes(TYPE_RENEWAL_R2R) && noti?.pages.includes(origin)
      );
      addNotification({ notification, notificationsList, text: formattedDate });
    }
  }
};

export const getPersonalAdvantageR2RNotifications = ({
  notificationsList,
  userInfo,
  origin,
}) => {
  if (userInfo?.userDiscountNewModelR2R && userInfo?.isUserNewModelR2R) {
    const formattedDiscount = `${userInfo.userDiscountNewModelR2R} € dto. en dispositivos`;
    const notification = NOTIFICATIONS.filter(
      (noti) =>
        noti?.type.includes(TYPE_PERSONAL_ADVANTAGE_R2R) &&
        noti?.pages.includes(origin)
    );
    addNotification({
      notification,
      notificationsList,
      text: formattedDiscount,
    });
  }
};

export const getEsimNotifications = ({
  esimStatusInfo,
  notificationsList,
  origin,
  productId,
}) => {
  const hasSecureEsimPendingCalc = hasSecureEsimPending();

  if (
    esimStatusInfo &&
    Array.isArray(esimStatusInfo) &&
    esimStatusInfo.length > 0
  ) {
    let productIdToDetail = null;
    if (origin === PRIVATE_AREA_TYPES.detalleMovil) {
      productIdToDetail = productId;
    }
    const productEsimPendingDownload = esimStatusInfo.filter(
      (product) =>
        product.pendingDownload &&
        (product.productId === productIdToDetail || !productIdToDetail)
    );
    // si tiene pendienteprovision y no tiene ninguna de las otras mostrar
    // la de pendiente, si tiene alguna pending no mostrar la de provision
    // TYPE_PENDING_ESIM
    if (
      productEsimPendingDownload &&
      Array.isArray(productEsimPendingDownload) &&
      productEsimPendingDownload.length > 0
    ) {
      addNotificationEsim({
        list: productEsimPendingDownload,
        type: TYPE_DOWNLOAD_ESIM,
        origin,
        notificationsList,
      });
    }
  }
};

const getTvNotifications = ({
  notificationsList,
  providerCompatibility,
  movistarLiteStatus,
  movistarLiteActivation,
  origin,
}) => {
  if (
    providerCompatibility &&
    Array.isArray(providerCompatibility?.disney?.compatibles) &&
    providerCompatibility?.disney?.compatibles.length > 0 &&
    providerCompatibility?.disney?.compatibles?.[0]?.estado === "I"
  ) {
    let notification = NOTIFICATIONS.filter(
      (noti) =>
        noti?.type.includes(TYPE_ACTIVATE_DISNEY) &&
        noti?.pages.includes(origin)
    );
    addNotification({ notification, notificationsList });
  }
  if (
    movistarLiteStatus &&
    movistarLiteStatus.products &&
    movistarLiteStatus.products.length > 0 &&
    movistarLiteStatus.products[0].active === false
  ) {
    let notification = NOTIFICATIONS.filter(
      (noti) =>
        noti?.type.includes(TYPE_ACTIVATE_MOVISTAR_PLUS) &&
        noti?.pages.includes(origin)
    );
    const url = getMovistarPlusLiteURL(movistarLiteStatus, movistarLiteActivation);
    notification[0].link = url;
    addNotification({ notification, notificationsList });
  }
};
export const getRestrictionsNotifications = ({
  notificationsList,
  origin,
  myLineDetailMobileRestrictionStatus,
  productId,
  hiredProductsList,
}) => {
  const hasRestriction = hasRestrictionByIdRestriction({
    myLineDetailMobileRestrictionStatus,
    idRestriction: "7",
  });
  if (hasRestriction) {
    const mobileLine = getProductsByProductId(hiredProductsList, productId);
    let notification = NOTIFICATIONS.filter(
      (noti) =>
        noti?.type.includes(BLOCKING_FOR_THEFT) && noti?.pages.includes(origin)
    );
    if (notification && notification[0] && notification[0].text) {
      notification[0].text = notification[0].text.replace(
        "{phone}",
        mobileLine?.number
      );
    }
    if (notification && notification[0] && notification[0].link) {
      notification[0].link = notification[0].link.replace(
        "{productId}",
        productId
      );
    }
    addNotification({ notification, notificationsList });
  }
};

export const getSelfEmployedNotifications = ({
  notificationsList,
  origin,
  selfEmployed,
}) => {
  if (selfEmployed) {
    let notification = NOTIFICATIONS.filter(
      (noti) => noti?.type.includes(MODEL_347) && noti?.pages.includes(origin)
    );
    addNotification({ notification, notificationsList });
  }
};

export function* getNotificationsData({ origin, productId, userRecom }) {
  try {
    const notificationsList = [];
    const [
      context,
      hiredProducts,
      accumulatedUsagesAlreadyFetched,
      listTracking,
      breakdownTracking,
      debtPayment,
      bills,
      claims,
      balancePrepaid,
      accumulatedUsagesPrepaid,
      tarifDetailPrepaidData,
      userInfo,
      esimStatusInfo,
      providerCompatibility,
      myLineDetailMobileRestrictionStatus,
      hiredProductsList,
      clientInfo,
      selfEmployed,
      movistarLiteActivation,
      movistarLiteStatus,
    ] = yield all([
      select(contextStore),
      select(getHiredProducts),
      select(getAccumulatedUsagesStore),
      select(listTrackingStore),
      select(breakdownTrackingStore),
      select(debtPaymentStore),
      select(billsStore),
      select(claimsStore),
      select(getBalancePrepaid),
      select(getAccumulatedUsagesPrepaid),
      select(getTarifDetailPrepaidData),
      select(getUserInfo),
      select(getEsimStatusInfo),
      select(getProviderCompatibility),
      select(getMyLineDetailMobileRestrictionStatus),
      select(getHiredProductsList),
      select(getClientInfoStore),
      select(getSelfEmployedStore),
      select(getMovistarLiteActivationStore),
      select(getMovistarLiteStatusStore),
    ]);

    if (userRecom)
      yield call(getCustoNotification, {
        context,
        notificationsList,
        origin,
        userRecom,
      });

    // getDebtPaymentNotification({ notificationsList, debtPayment, origin });
    getBreackingdownNotifications({
      notificationsList,
      breakdownTracking,
      origin,
      clientInfo,
    });
    getTrackingNotifications({ notificationsList, listTracking, origin });
    getUsagesNotifications({
      notificationsList,
      accumulatedUsagesAlreadyFetched,
      hiredProducts,
      origin,
      productId,
    });
    // getPromotionNotification({ notificationsList, hiredProducts, origin });
    getBillsNotifications({ notificationsList, billsObject: bills, claimsObject: claims, origin });
    if (
      balancePrepaid ||
      accumulatedUsagesPrepaid ||
      (accumulatedUsagesPrepaid && balancePrepaid && tarifDetailPrepaidData)
    ) {
      getPrepaidNotifications({
        origin,
        notificationsList,
        balancePrepaid,
        accumulatedUsagesPrepaid,
        tarifDetailPrepaidData,
      });
    }

    getTvNotifications({
      notificationsList,
      providerCompatibility,
      movistarLiteActivation,
      movistarLiteStatus,
      origin,
    });

    getPersonalAdvantageR2RNotifications({
      notificationsList,
      userInfo,
      origin,
    });

    getRenewalR2RNotifications({ notificationsList, userInfo, origin });

    getEsimNotifications({
      notificationsList,
      esimStatusInfo,
      origin,
      productId,
    });
    getRestrictionsNotifications({
      notificationsList,
      origin,
      productId,
      myLineDetailMobileRestrictionStatus,
      hiredProductsList,
    });
    // getSelfEmployedNotifications({ notificationsList, origin, selfEmployed });

    const notificationsListSort = [...notificationsList].sort(
      (a, b) => a.order - b.order
    );

    yield put(
      notificationsActions.getNotificationsSuccess(notificationsListSort)
    );
  } catch (error) {
    console.log(error);
    yield put(notificationsActions.failureGetNotifications(error));
  }
}
